import ResizeSensor from "resize-sensor";
import StickySidebar from "sticky-sidebar/dist/sticky-sidebar";
var isOnScreen = require("../util/isOnScreen");
var checkoutv2 = {};
var spacing;
var stickySidebar;
var lastScrollTop = 0;
var checkoutSidebar = $("#js-checkout-sidebar");
var nav = $(".js-header");
var checkoutSummary = $(".checkout-summary");
var msgHeight = "-" + nav.outerHeight() + "px";
checkoutv2.scroll = function () {
  var grandTotalLabel = $(".checkout-grand-total-mobile .breakdown-grand-total");
  window.addEventListener("scroll", function (e) {
    var checkoutTimeline = $("#js-checkout-steps");
    var timelineDeliverySection = $("#checkout-delivery");
    var timelinePaymentSection = $("#checkout-payment");
    var timelineShippingSection = $("#checkout-shipping");
    var timelineAdyenSection = $("#checkout-adyen");
    var timelineDelivery = $(timelineDeliverySection).data("timeline");
    var timelinePayment = $(timelinePaymentSection).data("timeline");
    var timelineShipping = $(timelineShippingSection).data("timeline");
    var timelineAdyen = $(timelineAdyenSection).data("timeline");

    // STICKY MOBILE
    if (grandTotalLabel.length) {
      if (isOnScreen(grandTotalLabel)) {
        $("body").removeClass("is-showingStickyTotal");
      } else {
        $("body").addClass("is-showingStickyTotal");
      }
    }

    // TIMELINE
    var $height = $(window).scrollTop();
    if ($height > 35) {
      if (matchMedia("screen and (min-width: 992px)").matches) {
        checkoutTimeline.addClass("is-fixed");
        checkoutSummary.css("padding-top", "100px");
      }
    } else {
      if (matchMedia("screen and (min-width: 992px)").matches) {
        checkoutTimeline.removeClass("is-fixed");
        checkoutSummary.css("padding-top", "0");
      }
    }

    // CUSTOM CODE SINCE HEADROOM IS REMOVE IN CHECKOUT
    if (matchMedia("screen and (max-width: 991px)").matches && nav.hasClass("is-checkout")) {
      var st = $(this).scrollTop();
      if (st == 0) {
        nav.css("transform", "translateY(0)");
      } else if (st > lastScrollTop) {
        nav.css("transform", "translateY(" + msgHeight + ")");
      } else {
        nav.css("transform", "translateY(0)");
      }
      lastScrollTop = st;
    }

    // Delivery
    if (isOnScreen(timelineDeliverySection)) {
      $(timelineDelivery).addClass("is-active");
    } else {
      $(timelineDelivery).removeClass("is-active");
    }

    // Payment
    if (isOnScreen(timelinePaymentSection) && timelinePaymentSection.is(":visible")) {
      $(timelineDelivery).addClass("is-active");
      $(timelinePayment).addClass("is-active");
    } else {
      $(timelinePayment).removeClass("is-active");
    }

    // Shipping
    if (isOnScreen(timelineShippingSection)) {
      $(timelineDelivery).addClass("is-active");
      $(timelinePayment).addClass("is-active");
      $(timelineShipping).addClass("is-active");
    } else {
      $(timelineShipping).removeClass("is-active");
    }

    // Adyen
    if (isOnScreen(timelineAdyenSection) && timelineAdyenSection.is(":visible")) {
      $(timelineDelivery).addClass("is-active");
      $(timelinePayment).addClass("is-active");
      $(timelineShipping).addClass("is-active");
      $(timelineAdyen).addClass("is-active");
    } else {
      $(timelineAdyen).removeClass("is-active");
    }
  });
};
checkoutv2.sticky = function () {
  var stickySide = document.getElementById("js-checkout-sidebar");
  var header = document.getElementsByClassName("js-header");
  var navHeight = 60;
  var checkoutStepsHeight = 35;
  var adminbarHeight = 32;
  if ($("body").hasClass("admin-bar")) {
    spacing = adminbarHeight + navHeight + checkoutStepsHeight;
  } else {
    spacing = navHeight + checkoutStepsHeight;
  }
  if (checkoutSidebar.length > 0) {
    stickySidebar = new StickySidebar(stickySide, {
      containerSelector: ".container",
      innerWrapperSelector: ".checkout-sidebar-inner",
      topSpacing: spacing,
      bottomSpacing: 0,
      minWidth: 992,
      resizeSensor: true
    });
    new ResizeSensor(header, function () {
      stickySidebar.updateSticky();
    });
  }
};
checkoutv2.autoFill = function () {
  function detectBrowsersAutofill() {
    var _this = this;
    setTimeout(function () {
      if ($(_this).is("input:-webkit-autofill") || $(_this).is("input:autofill")) {
        var clone = $(_this).clone(true, true);
        $(_this).after(clone);
        $(_this).remove();
      }
    }, 500);
  }
  $("#js-checkoutPaymentForm .form-control").on("input", detectBrowsersAutofill);
};
checkoutv2.init = function () {
  checkoutv2.scroll();
  checkoutv2.sticky();
  checkoutv2.autoFill();
};
$(window).on("resize", function () {
  if (checkoutSidebar.length > 0) {
    stickySidebar.updateSticky();
  }
  if (matchMedia("screen and (min-width: 992px)").matches) {
    nav.removeAttr("style");
  }
});
checkoutv2.init();


// WEBPACK FOOTER //
// ./scripts/components/checkoutv2.js